export default "__VITE_ASSET__Jen0vHq1__"